import { Check, Pencil, Flag, Trash2, Receipt } from "lucide-react";
import { Button } from "@/components/ui/button";
import { StatusBadge } from "@/components/StatusBadge";
import { fmtNum, fmtEur, fmtDate, stationColor, diffTone } from "@/lib/format";

const Item = ({ label, children, className = "" }) => (
  <div><p className="text-[11px] uppercase tracking-wider text-slate-400">{label}</p><p className={`font-mono-num text-sm font-medium ${className}`}>{children}</p></div>
);

export const AdminEntryCards = ({ rows, stations, overRate, actions }) => (
  <div className="space-y-3 md:hidden" data-testid="admin-control-cards">
    {rows.map((r) => (
      <div key={r.id} className="rounded-xl border border-slate-200 bg-white p-4" data-testid={`admin-card-${r.id}`}>
        <div className="flex items-start justify-between gap-2">
          <div>
            <p className="font-semibold">{fmtDate(r.date)}</p>
            <p className="flex items-center gap-2 text-sm text-slate-500"><span className="h-2 w-2 rounded-full" style={{ background: stationColor(stations, r.station_id) }} />{r.station_name}</p>
          </div>
          <StatusBadge status={r.status} testId={`admin-card-status-${r.id}`} />
        </div>
        <div className="mt-3 grid grid-cols-3 gap-3">
          <Item label="Gasolio">{fmtEur(r.total_cost)}</Item>
          <Item label="Rimborso">{fmtEur(r.reimbursement_amount)}</Item>
          <Item label="Diff. netta" className={`font-semibold ${diffTone(r.difference)}`}>{fmtEur(r.difference)}</Item>
          <Item label="KM">{fmtNum(r.kilometers, 0)}</Item>
          <Item label="Km Amazon">{fmtNum(r.reimbursed_km, 0)}</Item>
          <Item label="€/km netto" className={overRate(r) ? "text-rose-600" : ""}>{fmtNum(r.cost_per_km_net, 3)}</Item>
          <Item label="Mezzi">{r.vehicles_out ?? "—"}</Item>
          <Item label="km/l">{fmtNum(r.km_per_liter, 2)}</Item>
          <Item label="€/L">{fmtNum(r.fuel_price_per_liter, 3)}</Item>
        </div>
        {r.admin_notes && <p className="mt-3 rounded-md bg-rose-50 px-2 py-1 text-xs text-rose-700">{r.admin_notes}</p>}
        <div className="mt-3 flex justify-end gap-1 border-t pt-3">
          <Button size="sm" variant="ghost" disabled={r.status === "Approved"} onClick={() => actions.approve(r)} data-testid={`card-approve-${r.id}`} className="text-emerald-600"><Check className="h-4 w-4" /></Button>
          <Button size="sm" variant="ghost" onClick={() => actions.setReimbursing(r)} data-testid={`card-reimb-${r.id}`} className="text-blue-600"><Receipt className="h-4 w-4" /></Button>
          <Button size="sm" variant="ghost" onClick={() => actions.setEditing(r)} data-testid={`card-edit-${r.id}`}><Pencil className="h-4 w-4" /></Button>
          <Button size="sm" variant="ghost" onClick={() => actions.setRejecting(r)} data-testid={`card-reject-${r.id}`} className="text-rose-600"><Flag className="h-4 w-4" /></Button>
          <Button size="sm" variant="ghost" onClick={() => actions.remove(r)} data-testid={`card-delete-${r.id}`} className="text-slate-400"><Trash2 className="h-4 w-4" /></Button>
        </div>
      </div>
    ))}
    {rows.length === 0 && <p className="rounded-xl border border-dashed p-8 text-center text-sm text-slate-500">Nessun record per i filtri selezionati.</p>}
  </div>
);
